import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';

@Component({
    selector: 'check-box',
    templateUrl: './check-box.html',
    styleUrls: ['./check-box.scss'],
	encapsulation: ViewEncapsulation.None,
	// changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'class': 'st-checkbox'
	}
})

export class CheckBox extends EnpsControl<boolean> {
    public valueChanged(v) {
        this.changed.emit(v);
    }
}
